<form class="row g-3" (ngSubmit)="salvarRelogio()">
  <div class="col-12" *ngIf="jornadaQueValeNoPonto">
    <div class="alert alert-warning mb-0">
      <strong>Esta aba nao controla o ponto.</strong>
      Servidores em "Padrao do empregador" usam a jornada
      <strong>{{ jornadaQueValeNoPonto.nome }}</strong>
      <span *ngIf="jornadaQueValeNoPonto.padrao"> (marcada Padrao)</span>
      <span *ngIf="!jornadaQueValeNoPonto.padrao"> (nenhuma marcada Padrao; vale a de maior versao)</span>
      na aba Jornadas. Tolerancia e horarios daqui so valem se nao existir jornada cadastrada.
      <button type="button" class="btn btn-sm btn-outline-warning ms-2" (click)="irParaJornadas.emit()">
        Ir para Jornadas
      </button>
    </div>
  </div>

  <div class="col-md-6">
    <label class="form-label">Empregador</label>
    <select
      class="form-select"
      name="empregadorRelogio"
      [ngModel]="empregadorSelecionado"
      (ngModelChange)="selecionarEmpregador($event)"
      required>
      <option value="">Selecione</option>
      <option *ngFor="let item of empregadores" [value]="item.id">{{ item.razaoSocial }}</option>
    </select>
  </div>

  <div class="col-md-6 d-flex align-items-end">
    <div class="form-check form-switch pb-2">
      <input
        class="form-check-input"
        type="checkbox"
        role="switch"
        id="validarJanelaPonto"
        name="validarJanelaPonto"
        [(ngModel)]="relogioEmpregador.validarJanelaPonto">
      <label class="form-check-label" for="validarJanelaPonto">Validar janela de tolerancia</label>
      <div class="text-secondary small">Desligado: nao recusa por horario. Grava na proxima coluna vazia (1a, 2a, 3a, 4a).</div>
    </div>
  </div>

  <div class="col-md-3">
    <label class="form-label">Tolerancia em minutos</label>
    <input
      class="form-control"
      type="number"
      name="toleranciaMinutos"
      min="0"
      max="120"
      [(ngModel)]="relogioEmpregador.toleranciaMinutos"
      [disabled]="!relogioEmpregador.validarJanelaPonto">
  </div>

  <div class="col-md-3 d-flex align-items-end">
    <div class="text-secondary small">Cada batida vale dentro da janela de tolerancia antes e depois.</div>
  </div>

  <div class="col-md-3">
    <label class="form-label">1a batida</label>
    <input class="form-control" type="time" name="horarioPrimeiraBatida" [(ngModel)]="relogioEmpregador.horarioPrimeiraBatida" required>
  </div>

  <div class="col-md-3">
    <label class="form-label">2a batida</label>
    <input class="form-control" type="time" name="horarioSegundaBatida" [(ngModel)]="relogioEmpregador.horarioSegundaBatida" required>
  </div>

  <div class="col-md-3">
    <label class="form-label">3a batida</label>
    <input class="form-control" type="time" name="horarioTerceiraBatida" [(ngModel)]="relogioEmpregador.horarioTerceiraBatida" required>
  </div>

  <div class="col-md-3">
    <label class="form-label">4a batida</label>
    <input class="form-control" type="time" name="horarioQuartaBatida" [(ngModel)]="relogioEmpregador.horarioQuartaBatida" required>
  </div>

  <div class="col-12">
    <app-rodape-crud (limpar)="limparRelogio()" (salvar)="salvarRelogio()"></app-rodape-crud>
  </div>
</form>
